"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContinuationRouterJSON = void 0;
__exportStar(require("../idls/continuation_router"), exports);
var continuation_router_1 = require("../idls/continuation_router");
Object.defineProperty(exports, "ContinuationRouterJSON", { enumerable: true, get: function () { return continuation_router_1.ContinuationRouterJSON; } });
//# sourceMappingURL=continuationRouter.js.map